jQuery(window).load(function(){
	var $ = jQuery;

	// Convert SVGs
    $('._svg')
    	.shapeSvgConvert();
});